import { render, staticRenderFns } from "./stockAdjustment.vue?vue&type=template&id=280682fa&scoped=true&"
import script from "./stockAdjustment.vue?vue&type=script&lang=js&"
export * from "./stockAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./stockAdjustment.vue?vue&type=style&index=0&id=280682fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280682fa",
  null
  
)

export default component.exports